import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect } from "react"
import AdminTable from "../Administrator/Helpers/AdminTable"
import {
  formatIsoToDateNew,
  formatIsoToTime,
} from "src/components/helpers/formateDate"
import { Button, Modal, Flex, Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import {
  passagesAction,
  getPhoto,
} from "src/store/Slices/Administrator/PassagesSlice"
import { openNotification } from "src/components/helpers/notification"

const ClientsPassages = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  passagesInfo,
  setPassagesInfo,
  payload,
}) => {
  const dispatch = useDispatch()

  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false)

  // STORE
  const passagesList = useSelector((state) => state.PassagesSlice.passagesList)
  const passagesLoading = useSelector(
    (state) => state.PassagesSlice.passagesLoading
  )
  const photoList = useSelector((state) => state.PassagesSlice.photoList)
  const photoLoading = useSelector((state) => state.PassagesSlice.photoLoading)

  useEffect(() => {
    if (clientInfo?.id) {
      dispatch(
        passagesAction({
          flag: "get",
          value: {
            UserIdFrom: clientInfo.id,
            UserIdTo: clientInfo.id,
            Count: pageSize,
            Offset: (page - 1) * pageSize,
          },
        })
      )
    }
  }, [clientInfo?.id, page, pageSize])

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "date") {
            formattedItems["DateFrom"] = values[index][0]
            formattedItems["DateTo"] = values[index][1]
          } else if (key === "clubName") {
            formattedItems["clubId"] = values[index][0]
          } else {
            formattedItems[key] = values[index][0]
          }
        }
      })
      return formattedItems
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const searchPayload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    )
    dispatch(
      passagesAction({
        flag: "get",
        value: {
          UserIdFrom: clientInfo.id,
          UserIdTo: clientInfo.id,
          Count: pagination.pageSize,
          Offset: pagination.pageSize * (pagination.current - 1),
          OrderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...searchPayload,
        },
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const getPhotoList = (record) => {
    if (!record?.userId) {
      openNotification({
        type: "error",
        message: "Не удалось получить данные записи",
      })
      return
    }

    setIsPhotoModalOpen(true)
    dispatch(
      getPhoto({
        userId: record.userId,
      })
    ).then((result) => {
      if (!result.payload) {
        openNotification({
          type: "error",
          message: "Не удалось загрузить фото",
        })
      }
    })
  }

  const getColumns = () => {
    if (!passagesList) {
      return {
        data: {
          value: {
            columns: [
              {
                title: "Дата",
                dataIndex: "date",
                key: "date",
              },
              {
                title: "Клуб",
                dataIndex: "clubName",
                key: "clubName",
              },
              {
                title: "Тип прохода",
                dataIndex: "passageTypeName",
                key: "passageTypeName",
              },
              {
                title: "Действия",
                dataIndex: "action",
                key: "action",
                width: 150,
                render: (text, record) => (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Button type='primary' size='small'>
                      Получить фото
                    </Button>
                  </div>
                ),
              },
            ],
          },
        },
      }
    }

    const baseColumns = passagesList.data?.value?.columns || []

    const filteredColumns = baseColumns.filter(
      (col) => col.dataIndex !== "userId" && col.dataIndex !== "userName"
    )

    return {
      data: {
        value: {
          columns: [
            ...filteredColumns,
            {
              title: "Действия",
              dataIndex: "action",
              key: "action",
              width: 150,
              render: (text, record) => (
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    type='primary'
                    size='small'
                    onClick={() => {
                      getPhotoList(record)
                    }}
                  >
                    Получить фото
                  </Button>
                </div>
              ),
            },
          ],
        },
      },
    }
  }

  const formatedPassagesRows = passagesList?.data?.value?.rows?.map(
    (element) => {
      return {
        ...element,
        date: element.date
          ? formatIsoToDateNew(element.date) +
            " " +
            formatIsoToTime(element.date)
          : "",
      }
    }
  )

  return (
    <>
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={passagesLoading}
          onClickRowOne={setPassagesInfo}
          columns={getColumns()}
          rows={formatedPassagesRows}
          total={passagesList?.data?.value?.totalCount}
          title={title}
        />
      )}

      {isPhotoModalOpen && (
        <Modal
          open={isPhotoModalOpen}
          onCancel={() => {
            setIsPhotoModalOpen(false)
          }}
          title={<div style={{ fontSize: "30px" }}>Фото пользователя</div>}
          styles={{
            header: {
              textAlign: "center",
            },
            body: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
              paddingTop: "10px",
            },
          }}
          footer={null}
        >
          {photoList ? (
            <img
              src={photoList}
              alt='Фото прохода'
              style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
            />
          ) : (
            // <div>Идёт загрузка фото...</div>

            <Flex align='center' gap='middle'>
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
              />
            </Flex>
          )}
        </Modal>
      )}
    </>
  )
}

export default ClientsPassages
